import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Button } from '@astryxdesign/core/Button';
import { useToast } from '@astryxdesign/core/Toast';
import { onUpdateAvailable } from './pwa';

export function UpdatePrompt() {
  const intl = useIntl();
  const toast = useToast();
  useEffect(
    () =>
      onUpdateAvailable((apply) =>
        toast({
          body: intl.formatMessage({ id: 'app.updateAvailable' }),
          isAutoHide: false,
          uniqueID: 'app-update',
          endContent: <Button label={intl.formatMessage({ id: 'app.update' })} size="sm" onClick={apply} />,
        }),
      ),
    [intl, toast],
  );
  return null;
}
